<template>
  <div>
    <page-title pageName="员工管理"/>
    <div class='comm-container'>
      <div class='comm-page-container'>
        <el-row class='pd10'>
          <el-col :span='18'>
            <span class='comm-search-txt'>输入查询：</span>
            <el-input
              v-model='searchValue'
              class='comm-search-con'
              placeholder='员工名或登录账号'
              size='small'/>
            <el-button
              size='small'
              type="primary"
              class='ml10' @click='selectBtn'>查询</el-button>
            <el-button
              size='small' @click='resetBtn'>重置</el-button>
          </el-col>
          <el-col
            :span='6'
            class='text-right'>
            <el-button
              size='small'
              type="primary" @click='addBtn'>添加</el-button>
          </el-col>
        </el-row>
        <el-table
          ref="multipleTable"
          :data="tableData"
          border
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            align='center'
            width="55"/>
          <el-table-column
            sortable
            align='center'
            prop='userName'
            label="员工姓名">
            <template slot-scope="scope">
              <div>
                {{scope.row.userName ? scope.row.userName : '-'}}
              </div>
            </template>
          
          </el-table-column>
          <el-table-column
            sortable
            prop='userSex'
            align='center'
            label="性别">
            <template slot-scope="scope">
              <div>
                {{scope.row.userSex === 1 ? '男' : (scope.row.userSex === 0 ? '女' : '-')}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align='center'
            prop='userLoginName'
            label="登录账号"/>
          <el-table-column
            align='center'
            prop='userInitPassword'
            label="登录密码"/>
          <el-table-column
            align='center'
            width='200px'
            label="操作">
            <template slot-scope="scope">
              <div>
                <el-button size='mini' plain type="primary" @click='editBtn(scope.row)'>编辑</el-button>
                <el-button size='mini' plain type="danger" @click='delBtn(scope.row)'>删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class='com-only-pagination'>
          <el-row class='plr15'>
            <el-col :span='12'>
              <el-button
                size='small'
                type="danger" @click='batchDel'>批量删除</el-button>
            </el-col>
            <el-col :span='12' class='text-right'>
              <el-pagination
                :current-page="currentPage"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"/>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Classify',
  data () {
    return {
      searchValue:'',
      pageSizes: [20, 50, 60, 100],
      pageSize: 20,
      total: 0,
      currentPage:1,
      tableData: [],
      multipleSelection: []
    }
  },
  mounted(){
    this.getData()
  },
  methods: {
    getData(){
      this.tableData = []
      let params = {
        type:2,
        query:this.searchValue,
        pageSize:this.pageSize,
        pageNum:this.currentPage
      }
      this.$ajax({
        method:"post",
        url:'user/selectUserByPage',
        data:params
      }).then(res => {
        if(res.data.code > 0){
          this.tableData = res.data.data.list
          this.total = res.data.data.total
        }else{
          this.$message.warning(res.data.desc)
        }
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    delFun(data){
      this.$confirm('确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          method:'post',
          url:'user/deleteUser',
          data:data
        }).then(res => {
          if(res.data.code > 0){
            this.$message.success('删除成功！')
            this.getData()
          }else{
            this.$messgae.warning(res.data.desc)
          }
        })
      })
    },
    batchDel(){
      let params = []
      params = this.multipleSelection.map(item => {return item.userId})
      if(params.length === 0){
        this.$message.warning('请选择要删除的员工！')
        return
      }
      this.delFun(params)
    },
    addBtn(){
      localStorage.removeItem('userDetail')
      this.$router.push({
        path:'/addUser',
        query:{
          isStaff:1
        }
      })
    },
    editBtn(item){
      let obj = JSON.parse(JSON.stringify(item))
      obj.userSex = obj.userSex ? obj.userSex.toString() : null
      localStorage.removeItem('userDetail')
      localStorage.setItem('userDetail',JSON.stringify(item))
      this.$router.push({
        path:'/addUser',
        query:{
          isEdit:1
        }
      })
    },
    delBtn(item){
      let data = [item.userId]
      this.delFun(data)
    },
    selectBtn(){
      this.getData()
    },
    resetBtn(){
      this.searchValue = null
      this.getData()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getData()
    }
  }
}
</script>
